export default function usePlateauxPricing(prixParPersonne, personnes) {
  const p = Number(prixParPersonne || 0);
  const n = Number(personnes || 0);
  return p * n;
}
